import React from 'react';
import { Link } from 'react-router-dom';
import CONSTANTS from '../../../Constants';

const DealerSummary = (props) => {
    return (
        <div className='dealerDetails'>
            <div className='dealerBlock-title'>{CONSTANTS.LABELS.header_quote_dealer}</div>
            <div className='dealerBlock-name'>{props.dealerName}</div>
            <div className='dealerBlock-adress'>{`${props.dealerAddress} ${props.dealerZipCode} ${props.dealerCity}`}</div>
            <div tabIndex='0' role="button" className='edit-link' onClick={() => props.onEditClick('dealer')}>
                {CONSTANTS.LABELS.common_v2_modify}
            </div>
        </div>
    );

}

export default DealerSummary;